import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import styles from "../styles/menu.module.css";
import { userLogged } from "../userLogged";
import { logoutUser } from "../logoutUser";
import {
  ArrowBigLeftIcon,
  LogOutIcon,
  MenuIcon,
  Moon,
  Sun,
  X,
} from "lucide-react";
import { SwitchMode } from "./SwitchMode";
import { RadarChart } from "recharts";
import { ProfileRadarChart } from "./ProfileRadarChart";
import { ProfileRadarChartByAdmin } from "./ProfileRadarChartByAdmin";

export function AdminSkillsUser({ userData, darkMode }) {
  const [openAccordions, setOpenAccordions] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
    12: false
  });

  const toggleAccordion = (index) => {
    setOpenAccordions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <>
      <div className="card card-flush mb-6 mb-xl-9">
        <div className="card-header mt-6">
          <div className="card-title flex-column">
            <h2 className="mb-1">Pontuações das Habilidades</h2>
            <div className="fs-6 fw-semibold text-muted">Total 12 habilidades</div>
          </div>
        </div>

        <div className="card-body d-flex flex-column">
          <ProfileRadarChartByAdmin id="RadarChart" userId={userData.codUsuario} />
        </div>
      </div>

      <div className="card card-flush mb-6 mb-xl-9">
        <div className="card-header mt-6">
          <div className="card-title flex-column">
            <h2 className="mb-1">Textos das Habilidades</h2>
            <div className="fs-6 fw-semibold text-muted">
              12 textos gerados pela IA conforme as pontuações atingidas
            </div>
          </div>
        </div>

        {userData.relatorioEnviado == 1 ? (
            <div>
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[1] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(1)}
                role="button"
                aria-expanded={openAccordions[1]}
              >
                Inteligência Emocional
                <span
                  className={`ms-2 ${openAccordions[1] ? "rotate-180" : ""}`}
                >
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[1] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_inteligencia_emocional}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[2] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(2)}
                role="button"
                aria-expanded={openAccordions[2]}
              >
                Complexidade
                <span className={`ms-2 ${openAccordions[2] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[2] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }} >{userData.texto_complexidade}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[3] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(3)}
                role="button"
                aria-expanded={openAccordions[3]}
              >
                Tomada de Decisão
                <span className={`ms-2 ${openAccordions[3] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[3] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_tomada_de_decisao}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[4] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(4)}
                role="button"
                aria-expanded={openAccordions[4]}
              >
                Criatividade
                <span className={`ms-2 ${openAccordions[4] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[4] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_criatividade}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[5] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(5)}
                role="button"
                aria-expanded={openAccordions[5]}
              >
                Pensamento Crítico
                <span className={`ms-2 ${openAccordions[5] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[5] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_pensamento_critico}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[6] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(6)}
                role="button"
                aria-expanded={openAccordions[6]}
              >
                Flexibilidade Cognitiva
                <span className={`ms-2 ${openAccordions[6] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[6] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_flexibilidade_cognitiva}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[7] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(7)}
                role="button"
                aria-expanded={openAccordions[7]}
              >
                Adaptabilidade
                <span className={`ms-2 ${openAccordions[7] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[7] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_adaptabilidade}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[8] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(8)}
                role="button"
                aria-expanded={openAccordions[8]}
              >
                Colaboração em Equipe
                <span className={`ms-2 ${openAccordions[8] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[8] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_colaboracao_em_equipe}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[9] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(9)}
                role="button"
                aria-expanded={openAccordions[9]}
              >
                Empatia
                <span className={`ms-2 ${openAccordions[9] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[9] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_empatia}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[10] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(10)}
                role="button"
                aria-expanded={openAccordions[10]}
              >
                Relação com o Medo
                <span className={`ms-2 ${openAccordions[10] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[10] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_relacao_com_o_medo}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[11] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(11)}
                role="button"
                aria-expanded={openAccordions[11]}
              >
                Agilidade
                <span className={`ms-2 ${openAccordions[11] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[11] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_agilidade}</p>
              </div>
            </div>
  
            <div className="card-body d-flex flex-column">
              <div
                className={`fw-bold rotate collapsible ${
                  openAccordions[12] ? "" : "collapsed"
                }`}
                onClick={() => toggleAccordion(12)}
                role="button"
                aria-expanded={openAccordions[12]}
              >
                Inteliência Relacional
                <span className={`ms-2 ${openAccordions[12] ? "rotate-180" : ""}`}>
                  <i className="ki-outline ki-down fs-3"></i>
                </span>
              </div>
            </div>
  
            <div className="separator"></div>
  
            <div className={`collapse ${openAccordions[12] ? "show" : ""}`}>
              <div className="card-body d-flex flex-column">
                <p style={{ textAlign: 'justify' }}>{userData.texto_inteligencia_relacional}</p>
              </div>
            </div>
  
          </div>
        ) : (
        <div>
          <div className="card-body d-flex flex-column">
            <p>Usuário não terminou o questionário. Não possui informações suficientes</p>
          </div>
        </div>
        )}
      </div>
    </>
  );
}
